export default __webpack_public_path__ + "static/media/img-0655-lithuania-full-face.cf06c60d.png";